<template>
  <el-dialog v-model="visible" title="修改密码" :close-on-click-modal="false" :close-on-press-escape="false"
    :destroy-on-close="true" width="500px">
    <el-form ref="updatePassForm" :rules="rules" :model="updatePassForm" label-width="120px">
      <el-form-item label="原始密码:" prop="oldPassword">
        <el-input type="password" v-model="updatePassForm.oldPassword" auto-complete="off" placeholder="请输入密码"
          show-password></el-input>
      </el-form-item>
      <el-form-item label=" 新密码:" prop="newPassword" style="margin-top: 45px;">
        <el-input type="password" v-model="updatePassForm.newPassword" auto-complete="off" placeholder="请输入密码"
          show-password></el-input>
      </el-form-item>
      <el-form-item label="确认密码:" prop="mitPassword" style="margin-top: 45px;">
        <el-input type="password" v-model="updatePassForm.mitPassword" auto-complete="off" placeholder="请输入密码"
          show-password></el-input>
      </el-form-item>
      <el-row>
        <span style="color:red;padding-left: 20px;">*注：</span> <span style="color: darkgrey;">密码为8-20位，包含:(大小写字母、数字、特殊符号)中的三种!</span>
      </el-row>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="editPasswordSubmit()" :saveLoading="saveLoading">{{ saveLoading ? '提交中 ...' : '提 交' }}</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import { defineComponent } from 'vue';
import  {passwordValid}  from  "@/utils/passwordValid.js";
import { JSEncrypt } from 'jsencrypt'
import { getPubkey, updatePass } from '@/api/login';
import { mapGetters, mapActions } from 'vuex';

export default defineComponent({
  data() {
    const validateNewPassword = (rule, value, callback) => { // 验证新密码基础
      if (!value) {
        callback(new Error('请输入新密码'))
        return;
      }
      if (value === this.updatePassForm.oldPassword) {
        callback(new Error('新密码与旧密码相同'));
        return;
      }
      const valid = passwordValid(this.userName, value);
      if (valid === true) {
        callback();
      } else {
        callback(new Error(valid))
      }
    }
    const validateMitPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入确认密码'))
      } else if (value !== this.updatePassForm.newPassword) {
        callback(new Error('两次输入密码不一致'));
      } else {
        callback();
      }
    }
    return {
      visible: false,
      updatePassForm: {},
      rules: {
        oldPassword: [{ required: true, message: "请输入原始密码", trigger: "change" }],
        newPassword: [
          { required: true, validator: validateNewPassword, trigger: "change" }
          ],
        mitPassword: [{ required: true, validator: validateMitPassword, trigger: "change" }]
      },
      saveLoading: false
    }
  },
  computed: {
    ...mapGetters(['userName'])
  },
  methods: {
    ...mapActions(['removeAll']),
    show() {
      this.updatePassForm = {}
      this.visible = true;
    },
    //修改密码提交
    editPasswordSubmit() {
      this.$refs.updatePassForm.validate((valid) => {
        if (valid) {
          this.saveLoading = true;
          getPubkey().then(({data}) => {
            console.log('data:', data)
            if (data) {
              this.toUpdatePass(data);
            } else {
              this.saveLoading = false;
            }
          }).catch(_ => this.saveLoading = false);
        }        
      });
    },
    toUpdatePass(key) {
      //使用jsencrypt进行rsa加密
      let encrypt = new JSEncrypt()
      encrypt.setPublicKey(key);
      let encrypted = encrypt.encrypt(this.updatePassForm.oldPassword);
      let oldPass = encodeURI(encrypted).replace(/\+/g, '%2B');
      let newencrypted = encrypt.encrypt(this.updatePassForm.newPassword);
      let newPass = encodeURI(newencrypted).replace(/\+/g, '%2B');

      updatePass({oldPass, newPass}).then(({data}) => {
        if(data) {
          if(data.status){
            this.$message({ message: "密码修改成功，请重新登录", type: "success" });
            setTimeout(() => {
              this.removeAll();
              this.$router.push('/login');
            }, 2000);
            this.visible = false;
          } else {
            this.$message({ message: data.msg, type: "warning" });
          }        
        } else {
          this.$message({ message: "密码修改失败", type: "error" });
        }
        this.saveLoading = false;
      }).catch(_ => this.saveLoading = false);
    }
  }
})
</script>
